var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.625 1.375l-7.546 10.78a1.1 1.1 0 01-1.784.029l-1.92-2.559",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxNCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgZD0iTTEyLjYyNSAxLjM3NUw1LjA3OSAxMi4xNTQ1QzQuOTc5NDQgMTIuMjk3NiA0Ljg0NzMgMTIuNDE0OSA0LjY5MzQ5IDEyLjQ5NjlDNC41Mzk2NyAxMi41Nzg5IDQuMzY4NTggMTIuNjIzMSA0LjE5NDMgMTIuNjI2QzQuMDIwMDMgMTIuNjI4OSAzLjg0NzU2IDEyLjU5MDMgMy42OTExMiAxMi41MTM1QzMuNTM0NjggMTIuNDM2NiAzLjM5ODc0IDEyLjMyMzcgMy4yOTQ1IDEyLjE4NEwxLjM3NSA5LjYyNSIKICAgIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiIC8+Cjwvc3ZnPg==";
export { SvgCheck as ReactComponent };